import React, { useCallback, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  isEmptyCollection,
  SiteConfigManager,
  useCasinoNewState,
  useCategoryGamesState,
} from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { ChipsItem, Icon, Label } from '@atlas/ui';

import { BASE_PATH } from 'common/constants';
const { All_PROVIDERS } = COMPONENT_TYPES;

import ProvidersBlockSlider from './ProvidersBlockSlider';

const ProvidersFilterBlock = ({ onProviderClick, source }) => {
  const {
    group,
    providers: { data: providers },
  } = useCasinoNewState();
  const { loading: categoryGamesLoading } = useCategoryGamesState();
  const [swiper, setSwiper] = useState(null);
  const allProvidersPagePath = SiteConfigManager.getComponentPath(All_PROVIDERS);
  const allProvidersPage = SiteConfigManager.getConfig('config.pages').find(
    page => page.type === All_PROVIDERS,
  );
  const { push: historyPush } = useHistory();
  const location = useLocation();

  const showAllProvidersHandler = useCallback(
    () => historyPush(allProvidersPagePath, { casinoPathname: location.pathname, group, source }),
    [allProvidersPagePath, group, historyPush, location.pathname, source],
  );

  if (isEmptyCollection(providers) || categoryGamesLoading) {
    return null;
  }

  const prevSlide = () => swiper && swiper.slidePrev();
  const nextSlide = () => swiper && swiper.slideNext();

  return (
    <div className="casino-providers-block">
      <div className="casino-providers-block__header">
        <div className="casino-providers-block__name">
          <div
            className="casino-providers-block__icon"
            style={{
              backgroundImage: `url("${BASE_PATH}/static/assets/icons/icon-settings.png")`,
            }}
          />
          <Label className="casino-providers-block__title" message="providers_title" />
        </div>
        {allProvidersPage.isActive && (
          <ChipsItem
            className="casino-providers-block__view-all"
            label={<Label className="casino-providers-block__view-all-text" message="View_All" />}
            onClick={showAllProvidersHandler}
          />
        )}
        <>
          <ChipsItem
            className="casino-providers-block__slider-arrow arrow-left"
            label={<Icon name="arrow-left" />}
            onClick={prevSlide}
          />
          <ChipsItem
            className="casino-providers-block__slider-arrow arrow-right"
            label={<Icon name="arrow-right" />}
            onClick={nextSlide}
          />
        </>
      </div>
      <ProvidersBlockSlider
        onProviderClick={onProviderClick}
        providers={providers}
        setSwiper={setSwiper}
      />
    </div>
  );
};

export default ProvidersFilterBlock;

ProvidersFilterBlock.propTypes = {
  onProviderClick: PropTypes.func,
  source: PropTypes.string,
};
